<template>
  <div class="reporte-contactos">
    <v-card class="elevation-2" outlined>
      <v-tabs v-model="tab" grow>
        <v-tabs-slider color="green"></v-tabs-slider>

        <v-tab>
          <v-icon left>mdi-chart-box-outline</v-icon>
          Reporte general
        </v-tab>

        <v-tab>
          <v-icon left>mdi-file-sign</v-icon>
          Aceptacion de terminos
        </v-tab>
      </v-tabs>

      <v-divider></v-divider>

      <v-card-text class="pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <ReporteContactosT1 />
          </v-tab-item>

          <v-tab-item>
            <ReporteContactosT2 />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import ReporteContactosT1 from './reporte-contactos_t1.vue';
  import ReporteContactosT2 from './reporte-contactos_t2.vue';

  export default {
    components: {
      ReporteContactosT1,
      ReporteContactosT2,
    },
    data() {
      return {
        tab: 0,
      };
    },
  };
</script>

<style scoped>
.reporte-contactos {
  padding: 0 16px;
}
</style>
